import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import WalletsTerms from "../../components/WalletsTerms/WalletsTerms"
import {AllowedWalletsTermsColumns, WalletsTermsColumns} from "../../components/WalletsTerms/WalletTerms.types"
import {useIsBankUser, useIsOrgUser, useIsUnitUser, UserType} from "../../services/auth"
import {useNavigate} from "react-router-dom"
import Icon from "../../components/Icon/Icon"
import {HasPermission} from "../../containers/PermissionedUser/Permission"

const DEFAULT_INCLUDED_COLUMNS: Array<AllowedWalletsTermsColumns> = [
	WalletsTermsColumns.id,
	WalletsTermsColumns.name,
	WalletsTermsColumns.createdAt,
]

const UNIT_USER_INCLUDED_COLUMNS: Array<AllowedWalletsTermsColumns> = [
	WalletsTermsColumns.id,
	WalletsTermsColumns.status,
	WalletsTermsColumns.org,
	WalletsTermsColumns.name,
	WalletsTermsColumns.bank,
	WalletsTermsColumns.createdAt,
]

const ORG_USER_INCLUDED_COLUMNS: Array<AllowedWalletsTermsColumns> = [
	WalletsTermsColumns.id,
	WalletsTermsColumns.status,
	WalletsTermsColumns.name,
	WalletsTermsColumns.bank,
	WalletsTermsColumns.createdAt,
]

const BANK_USER_INCLUDED_COLUMNS: Array<AllowedWalletsTermsColumns> = [
	WalletsTermsColumns.id,
	WalletsTermsColumns.name,
	WalletsTermsColumns.org,
	WalletsTermsColumns.createdAt,
]

const INCLUDED_COLUMNS: Record<string, Array<AllowedWalletsTermsColumns>> = {
	[UserType.Unit]: UNIT_USER_INCLUDED_COLUMNS,
	[UserType.Bank]: BANK_USER_INCLUDED_COLUMNS,
	[UserType.Org]: ORG_USER_INCLUDED_COLUMNS,
}

function includedColumns(userType: string): Array<AllowedWalletsTermsColumns> {
	return INCLUDED_COLUMNS[userType] || DEFAULT_INCLUDED_COLUMNS
}

export default function WalletsTermsPage(): ReactElement {
	const navigate = useNavigate()
	const unitUserType = useIsUnitUser() && UserType.Unit
	const bankUserType = useIsBankUser() && UserType.Bank
	const orgUserType = useIsOrgUser() && UserType.Org
	const userType = unitUserType || bankUserType || orgUserType || ""

	return (
		<>
			<TitleBar title={"Wallet Terms"}>
				<HasPermission resource="walletTerms" action="create">
					<button className="button button-create" onClick={() => navigate("/wallet-terms/new")}>
						<Icon icon="interface-add-1" size={12} /> Create
					</button>
				</HasPermission>
			</TitleBar>

			<MainSectionTable>
				<WalletsTerms limit={40} enableTitle={false} fullHeight={true} includedColumns={includedColumns(userType)} />
			</MainSectionTable>
		</>
	)
}
